import { GetWeavePopNotificationByType } from '@frontend/types';
import { useCommonActionSubscriptions } from './actions/use-common-actions-subscriptions';
import { useNotificationActionSubscription } from './actions/use-notification-action-subscription';
import { useNotification } from './use-notification';

type Props = {
  onView?: (payload: GetWeavePopNotificationByType<'ai-receptionist-state'>) => void;
};

export const useAiReceptionistStateNotification = ({ onView }: Props = {}) => {
  useCommonActionSubscriptions('ai-receptionist-state');
  const { create, remove } = useNotification<'ai-receptionist-state'>();
  useNotificationActionSubscription('ai-receptionist-state', 'ignore', (e) => {
    remove(e.notification.id);
  });

  useNotificationActionSubscription('ai-receptionist-state', 'timed-out', (e) => {
    remove(e.notification.id);
  });

  useNotificationActionSubscription(
    'ai-receptionist-state',
    'view',
    ({ notification }) => {
      onView?.(notification);
      remove(notification.id);
    },
    [onView]
  );

  return {
    create,
    remove,
  };
};
